<template>
  <cg-layout
    class="cg-default-warp"
    :menuDataList="MenuDataList"
    :menuMsgCountStyle="MenuMsgCountStyle"
    :selectMenuKeys="SelectedMenuKeys"
    @menuClick="OnMenuClick"
  >
    <div v-if="LogoHtml" slot="logo" v-html="LogoHtml"></div>
    <template v-else-if="LogoUrl" slot="logo">
      <img class="default-logo" :src="LogoUrl" />
    </template>

    <template slot="headerContent">
      <div class="header-center-warp">

        <div class="header-center-toolbar">

          <a-tooltip placement="bottom">
            <template slot="title">
              <span>刷新页面</span>
            </template>
            <a-button
              class="header-opt-btn"
              type="link"
              icon="reload"
              @click="RefreshUserForm"
            ></a-button>
          </a-tooltip>

          <a-tooltip placement="bottom">
            <template slot="title">
              <span>任务列表</span>
            </template>
            <cg-task v-model="IsShowTaskPanel">
              <a-button
                class="header-opt-btn"
                type="link"
                icon="exception"
              ></a-button>
            </cg-task>
          </a-tooltip>

        </div>

        <div class="header-center-flex">
          <cg-import-template 
            v-if="HeaderCenterTemplateEntry"
            :entry="HeaderCenterTemplateEntry"
            name="HeaderCenterTemplate" />
        </div>

        <div class="header-center-toolbar">
          
          <span class="user-info" v-if="CurSaasClient">

            <a-select v-if="SaasClientList.length > 1" v-model="CurSaasClientID" 
              style="min-width: 200px;" @change="SubmitCurSaasClient">
              <a-select-option v-for="(item, index) in SaasClientList" 
                :key="index" :value="item.saas_client_id">
                {{ item.saas_client_desc }}
              </a-select-option>
            </a-select>

            <template v-else>
              {{ CurSaasClient.saas_client_desc }}
            </template>
          </span>

          <a-dropdown :trigger="['hover']">
            <span class="user-info">
              <a-avatar size="small" icon="user" />
              {{ LoginInfo.UserName }} <a-icon type="down" />
            </span>

            <a-menu slot="overlay">
              <a-menu-item
                v-show="ChangePasswordUserFormID"
                class="logout-btn"
                @click="ChangePassword"
              >
                <a-icon type="lock" /> 修改密码
              </a-menu-item>
              <a-menu-item class="logout-btn" @click="ExitLogin">
                <a-icon type="logout" /> 退出
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          
        </div>

      </div>
    </template>

    <keep-alive>
      <router-view
        v-if="CurUserForm"
        :userForm="CurUserForm"
        :key="
          CurUserForm.SubsysGUID
            ? CurUserForm.SubsysGUID
            : CurUserForm.UserFormID + '_' + CurUserForm.OnlyKey
        "
      />
    </keep-alive>
    
  </cg-layout>
</template>
<script>
import CgLayout from "../Layout";
import DefaultMixin from "../../Mxins/DefaultMixin";
import SubsysMixin from "../../Mxins/SubsysMixin";
import CmnMis from 'CmnMis';

export default {
  components: { CgLayout },
  mixins: [window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ ? SubsysMixin : DefaultMixin],
  data() {
    return {
      Collapsed: false,
      SelectedMenuKeys: [],
      LogoUrl: "",
      LogoHtml: "",
      ChangePasswordUserFormID: "",
      SaasClientModalVisible: false,
      SaasClientList: [],
      CurSaasClient: null,
      CurSaasClientID: "",
      MenuMsgCountStyle: {},
      HeaderCenterTemplateEntry: SiteConfig.HeaderCenterTemplate
    };
  },
  computed: {
    CurUserForm() {
      return CmnMis.CurUserForm;
    },
    //登录信息
    LoginInfo() {
      return this.$store.state.LoginInfo;
    },
    //当前用户表单
    CurUserForm() {
      return this.$store.state.CurUserForm;
    },
    //是否显示任务面板
    IsShowTaskPanel: {
      get() {
        return this.$store.state.TaskPanelVisible;
      },
      set(val) {
        this.$store.commit("SetTaskPanelVisible", val);
      }
    },
    //显示的菜单数据列表
    MenuDataList() {
      let _menuTree = [];

      let _getModuleData = (item, parentItem) => {
        return {
          ParentName: parentItem ? parentItem.Name : "",
          ModuleID: item.ModuleID,
          Name: `m_${item.ModuleID}`,
          Desc: item.ModuleDesc,
          ModuleIcon: item.ModuleIcon,
          Children: [],
        };
      };

      //格式化数据
      let _formatData = function (menuItem, treeItem) {
        //存在子表单
        menuItem.UserForms &&
          treeItem.Children.push(
            ...menuItem.UserForms.map((uf) => {
              let _treeItem = {
                ParentName: treeItem.Name,
                ModuleID: menuItem.ModuleID,
                UserFormID: uf.UserFormID,
                Name: `f_${uf.UserFormID}`,
                Desc: uf.FormDesc,
                TableName: uf.TableName,
                FormUrl: uf.FormUrl,
                PageSize: "10",
                SubsysSysGuid: uf.SubsysSysGuid,
                SubsysUserFormID: uf.SubsysUserFormID,
                UserFormKey: uf.UserFormKey,
              };

              return _treeItem;
            })
          );

        //存在子模块
        menuItem.Sons &&
          menuItem.Sons.forEach((item) => {
            let _treeItem = _getModuleData(item, treeItem);

            treeItem.Children.push(_treeItem);

            _formatData(item, _treeItem);
          });
      };

      this.$store.state.MenuDataList?.forEach((item) => {
        let _treeItem = _getModuleData(item);

        _menuTree.push(_treeItem);

        _formatData(item, _treeItem);
      });

      return _menuTree;
    },
    //菜单数据Map 方便查找
    MenuDataMap() {
      let _menuDataMap = {};

      let _menuDataList = this.MenuDataList?.concat([]);
      for (let _i = 0; _i < _menuDataList.length; _i++) {
        let _menuData = _menuDataList[_i];
        _menuDataMap[_menuData.Name] = _menuData;

        if (_menuData.Children && _menuData.Children.length > 0) {
          _menuDataList = _menuDataList.concat(_menuData.Children);
        }
      }

      return _menuDataMap;
    }
  },
  watch: {
    MenuDataList() {
      let _userformID = this.$route.params.ufid;

      // 处理子系统页面的刷新
      if (this.$route.params.sysguid && _userformID) {
        const menuItem = this.GetMenuItem(this.$route.params.sysguid, _userformID);
        if (menuItem) {
          this.SelectedMenuKeys = [menuItem.Name];
          this.ShowUserForm(menuItem.UserFormID);
          return;
        }
      }

      if (!_userformID) {
        //不存在查找第一个表单
        let _getMenuDataByMid = (menuList, mid) => {
          let _module = mid ? menuList.find((m) => m.ModuleID === mid) : menuList[0];

          let _menuData = null;

          while (_module) {
            if (_module.Children) {
              _module = _module.Children[0];
            } else {
              _menuData = _module;
              _module = null;
            }
          }

          return _menuData;
        };

        let _menuData = _getMenuDataByMid(this.MenuDataList, "");
        if (_menuData) {
          this.SelectedMenuKeys = [_menuData.Name];
          this.ShowUserForm(_menuData.UserFormID);
        }
      } else {
        // Cgl.Object.Each(this.MenuDataMap, (item) => {
        //   if (item.UserFormID == _userformID) {
        //     this.SelectedMenuKeys = [item.Name];
        //     return false;
        //   }
        // });

        //有可能在菜单里隐藏，没有数据，直接设置选中
        this.SelectedMenuKeys = ["f_" + _userformID];
        this.ShowUserForm(_userformID);
      }
    }
  },
  methods: {
    //根据表单查找菜单
    FindMenuItemByUserForm(userForm) {
      let list = [].concat(this.MenuDataList);
      for (let i = 0; i < list.length; i++) {
        if (
          list[i].UserFormID === userForm.UserFormID ||
          (userForm.UserFormKey && list[i].UserFormKey === userForm.UserFormKey)
        ) {
          return list[i];
        }
        if (Array.isArray(list[i].Children)) {
          list = list.concat(list[i].Children);
        }
      }
      return null;
    },
    //获取菜单项
    GetMenuItem(sysGUID, userFormId) {
      let list = [...this.MenuDataList];

      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item.SubsysSysGuid === sysGUID && item.SubsysUserFormID === userFormId) {
          return item;
        }
        list = list.concat(item.Children || []);
      }
      return null;
    },
    //点击菜单
    OnMenuClick({ item, key, keyPath }) {
      
      let _menuData = this.MenuDataMap[key];
      if (_menuData) {
        if (!!_menuData.FormUrl) {
          if (Cgl.Str.Trim(_menuData.FormUrl).match(/^[^\s\(\)\,]+$/) !== null) {
            if (_menuData.FormUrl.indexOf("Tools") == 0) {
              let _formUrl = CmnMis.Func.CgUrlToRootUrl("Manage/" + _menuData.FormUrl);

              window.open(_formUrl);
            } else {
              window.open(_menuData.FormUrl);
            }
          } else {
            eval(_menuData.FormUrl);
          }
        } else {
          this.SelectedMenuKeys = [key];
          this.ShowUserForm(key.replace("f_", ""), true);
        }
      }
    },
    //显示用户表单
    ShowUserForm(userformID, isClickMenuItem) {
      let _viewStateData = { IsShowPreUserForm: "0" };

      if (
        !isClickMenuItem &&
        userformID === this.$route.params.ufid &&
        Cgl.Url.GetParamFromUrl("ViewStateData") !== ""
      ) {
        _viewStateData = $.parseJSON(
          decodeURIComponent(Cgl.Url.GetParamFromUrl("ViewStateData"))
        );
      }

      CmnMis.Frame.ShowUserForm(userformID, _viewStateData);
    },
    //刷新用户表单
    RefreshUserForm() {
      CmnMis.Frame.ShowUserForm(
        CmnMis.CurUserForm.UserFormID,
        CmnMis.CurUserForm.GetViewStateData()
      );
    },
    //退出登录
    ExitLogin() {
      CmnMis.Func.CallItf("ExitLogin").then((data) => {
        if (data.IsSuccess === "1") {
          this.$store.commit("AddLoginInfo", { UserID: "" });
          CmnMis.Func.JumpToLoginPage(location.href);
        } else {
          Cmn.Modal.Alert(data.ErrMsg);
        }
      });
    },
    //修改密码
    ChangePassword() {
      CmnMis.Frame.ShowUserForm(this.ChangePasswordUserFormID);
    },
    //初始化当前SaaS客户
    async InitCurSaasClient() {

      //获取Saas客户列表
      let _data = await CmnMis.Func.CallItf("GetSaasClientList");

      if(_data.IsSuccess == "1" && _data.IsEnableSaas == "1") {

        //不存在当前Saas客户代码退出登录
        if(!_data.CurSaasClientID) {
          this.ExitLogin();
          return;
        }

        let _saasClientList = this.SaasClientList = _data.data || [];

        let _curSaasClien = _saasClientList.find(item => item.saas_client_id == _data.CurSaasClientID);
        
        //列表里没有当前Saas客户代码退出登录
        if(!_curSaasClien) {
          this.ExitLogin();
          return;
        }

        //还要再设置一遍当前客户代码，防止需要设置序列号
        _data = await CmnMis.Func.CallItf("SetCurClientID", {
          cmn_SaasClientID: _curSaasClien.cmn_SaasClientID
        });

        //设置成功
        if(_data.IsSuccess == "1") {

          if(_data.cmn_SaasClientID != _curSaasClien.cmn_SaasClientID) {

            _curSaasClien = _saasClientList.find(item => item.cmn_SaasClientID == _data.cmn_SaasClientID);
        
            //列表里没有当前Saas客户代码退出登录
            if(!_curSaasClien) {
              this.ExitLogin();
              return;
            }
          }

          this.CurSaasClientID = _curSaasClien.saas_client_id;
          this.CurSaasClient = _curSaasClien;

          //saas客户过期时间
          let _licenseValidDate = await CmnMis.Func.GetSaasClientCfg("LicenseValidDate");

          if(_licenseValidDate) {

            var _date = new Date(_licenseValidDate);

            if(_date != "Invalid Date" && _date.getTime() <= new Date().getTime() + 1000*60*60*24*30) {

              this.$notification["warning"]({
                message: '当前Saas客户过期提醒',
                description: `当前Saas客户将于${_date.getFullYear()}年${_date.getMonth() + 1}月${_date.getDate()}日过期，请联系系统管理员`,
                duration: 6
              });
            }
          }
        }
        //需要设置序列号的话
        else if(_data.IsResetSN) {
          this.ExitLogin();
        }
      }
    },
    //提交当前Saas客户
    async SubmitCurSaasClient() {

      let _saasClient = this.SaasClientList.find(item => item.saas_client_id == this.CurSaasClientID);

      let _data = await CmnMis.Func.CallItf("SetCurClientID", {
        cmn_SaasClientID: _saasClient.cmn_SaasClientID
      });

      if(_data.IsSuccess == "1") {

        window.location.reload();
      }
      //是否需要重新设置SN
      else if (_data.IsResetSN || _data.ErrMsg.indexOf("软件序列号非法") >= 0) {

        Cmn.Modal.Confirm(_data.ErrMsg, ()=>{

          var _href = "tools/SetSN.htm?SysName=" + Cgl.Url.GetParamFromUrl("SysName");

          _href += "&ReturnUrl=" + encodeURIComponent(window.location.href);

          _href += "&cmn_SaasClientID=" + encodeURIComponent(_saasClient.cmn_SaasClientID);

          window.location.href = _href;
          
        }, ()=>{
          this.CurSaasClientID = this.CurSaasClient.saas_client_id;
        });

      }
      else {
        Cmn.Modal.Alert(_data.ErrMsg);
      }
    }
  },
  mounted() {

    CmnMis.Frame.OnFrameInitComplete.Add(() => {

      //logo配置
      CmnMis.Func.GetSysCfg("LogoHtml").then((logoHtml) => {
        if (logoHtml) {
          this.LogoHtml = logoHtml;
        } else {
          CmnMis.Func.GetSysCfg("LogoUrl").then((logoUrl) => {

            if(logoUrl !== ".") {
              logoUrl = CmnMis.Func.CgUrlToRootUrl(logoUrl);
            }

            this.LogoUrl = logoUrl;
          });
        }
      });

      //修改密码的表单代码
      CmnMis.Func.GetSysCfg("ChangePasswordUserFormID").then((userFormID) => {
        this.ChangePasswordUserFormID = userFormID;
      });

      //系统将于*****年*月*日过期，请联系系统管理员
      CmnMis.Func.GetSysCfg("LicenseValidDate").then((licenseValidDate) => {
           
        if(licenseValidDate) {

          var _date = new Date(licenseValidDate);

          if(_date != "Invalid Date" && _date.getTime() <= new Date().getTime() + 1000*60*60*24*30) {

            this.$notification["warning"]({
              message: '系统过期提醒',
              description: `系统将于${_date.getFullYear()}年${_date.getMonth() + 1}月${_date.getDate()}日过期，请联系系统管理员`,
              duration: 6
            });
          }
        }
      });

      //菜单信息数样式
      CmnMis.Func.GetSysCfg("MenuMsgCountStyle").then((style)=>{

        if(style) {
          this.MenuMsgCountStyle = JSON.parse(style);
        }
      });

      this.InitCurSaasClient();

    }, "__DefaultView__");
  }
};
</script>
<style>
.cg-default-warp .header-center-warp {
  display: flex;
}

.cg-default-warp .header-center-flex {
  flex: 1;
}

.cg-default-warp .user-info {
  /* float: right; */
  height: 64px;
  line-height: 64px;
  padding: 0 12px;
  cursor: pointer;
  margin-right: 10px;
}
/* .cg-default-warp .user-info:hover {
  background: rgba(0, 0, 0, 0.025);
} */
.cg-default-warp .header-opt-btn {
  font-size: 18px;
  color: inherit;
}
</style>
